module.exports = __webpack_public_path__ + "media/images/country_flags/ad-c770d4a6584322df60c132814d10ecf8.png";